import axios from 'axios';
import { auth } from '../firebase';

// API base URL - uses proxy in package.json for local development
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if user is logged in
api.interceptors.request.use(
  async (config) => {
    try {
      // Get current Firebase user and their token
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      }

      // For FormData (file uploads), remove default Content-Type
      // so the browser can set the correct multipart/form-data boundary.
      // Use multiple approaches for axios 1.x AxiosHeaders compatibility.
      if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
        if (config.headers.set) {
          config.headers.set('Content-Type', undefined);
        }
      }
    } catch (error) {
      console.error('Error getting auth token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized - could redirect to login
      console.warn('Unauthorized request - user may need to log in');
    }
    return Promise.reject(error);
  }
);

export default api;
